// CopeCart Checkout-URLs pro Aufsteller-Variante (Slug → URL)
// Bei "custom" gibt es noch keinen Link → Anfrage-Flow bleibt erhalten.

export const CHECKOUT_URLS = {
  "google-white": "https://copecart.com/products/ba6d92f4/checkout",
  "google-black": "https://copecart.com/products/adfd45f4/checkout",
  "instagram-gradient": "https://copecart.com/products/5a5d727d/checkout",
  "facebook-blue": "https://copecart.com/products/abb97c38/checkout",
  "tiktok-neon": "https://copecart.com/products/8b1dd742/checkout",
  "paypal-pay": "https://copecart.com/products/7d46a404/checkout",
  "whatsapp-chat": "https://copecart.com/products/f61af96b/checkout",
};
